<style lang="less" scoped>
.td_left {width: 200px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
.after {text-align: left;background-color: #fcfcfc;}
.after .el-button {height: 40px;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
.f_hids {width:200px;color: #ffffff;margin-right: 5px;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.td {margin-left: 10px;}
.spans {margin-left: 140px;color: #606266;}
table {border-collapse: collapse;width: 100%;}
.el-checkbox__inner {border-radius: 50%;}
.first .introduce {width: 100%;}
.first .introduce1 {width: 750px;}
.first /deep/ .el-input {width: 400px;}
.level /deep/ .el-input {width: 200px;}
.ssgj_tr /deep/ .el-input {width: 400px;}
.btnfixed {margin: 0px auto;height: 60px;z-index: 9999;}
.btnfixed .el-button {height: 40px;margin: 10px auto;margin-top: 10px;}
.edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
.el-form-item {margin-bottom: 0;float: left;}
.jianjie_tr .el-form-item {width: 99%;}
.catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
.tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
/deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
.currency /deep/.el-input {width: 195px;}
.input2{margin-left: 10px;}
/deep/.input2.el-input {width: 195px;}
/deep/.video-js .vjs-big-play-button{top: 45%;left: 45%;}
/deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
/deep/.hide .el-upload--picture-card {display: none;}
</style>

<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" :rules="rules" class="formBox">
      <table>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('company')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司名称
          </td>
          <td class="after title_right" v-if="this.$route.path === '/Qyzsgl' || '/QyzsUpdate'">
            <el-form-item>
              <el-input v-model="form.company" placeholder="请输入公司名称" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('company')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司级别
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-select clearable v-model="form.level" placeholder="级别">
                <el-option v-for="item in level_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('type')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司类型
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.type" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in options_companyType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>形象图片
          </td>
          <td class="after">
            <el-upload
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic1"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('bannerthumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>横幅
          </td>
          <td class="after">
            <el-upload
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic4"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess2"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>企业简介
          </td>
          <td class="after" >
            <el-form-item>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" class="introduce" v-model="form.introduce"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>主营行业
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.catid" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in options_Mainindustry" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('business')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>主要经营范围
          </td>
          <td class="after" >
            <el-form-item>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" class="introduce" v-model="form.business"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="ssgj_tr">
          <td class="td_left">
            <span v-if="isMandatory('mode')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>经营模式
          </td>
          <td class="after">
            <el-checkbox-group v-model="form.mode" :min="0" :max="2">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
            <span class="spans">(最多可选2种)</span>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('size')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司规模
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.size" placeholder="" class="select classification">
                <el-option v-for="item in options_companySize" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select>
            </el-form-item>
          </td>
        </tr>
         <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('regunit')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>注册资本
          </td>
          <td class="after" >
            <el-form-item>
              <el-select clearable v-model="form.regunit" placeholder="" class="select classification currency">
                <el-option v-for="item in options_registeredCapital" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-input v-model="form.capital" placeholder="" class="input2"></el-input> 万
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('regyear')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司成立年份
          </td>
          <td class="after" >
            <el-input v-model="form.regyear" placeholder=""></el-input>（年份，如：2004）
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('address')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司地址
          </td>
          <td class="after" >
            <el-input v-model="form.address" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('postcode')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>邮政编码
          </td>
          <td class="after" >
            <el-input v-model="form.postcode" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('telephone')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司电话
          </td>
          <td class="after" >
            <el-form-item prop="telephone">
              <el-input v-model="form.telephone" placeholder=""></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('fox')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司传真
          </td>
          <td class="after" >
            <el-form-item prop="fax">
              <el-input placeholder="" v-model="form.fax"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('mail')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司Email
          </td>
          <td class="after" >
            <el-form-item prop="mail">
              <el-input v-model="form.mail" placeholder=""></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('homepage')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公司网址
          </td>
          <td class="after" >
            <el-form-item prop="homepage">
              <el-input v-model="form.homepage" placeholder=""></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('contacts')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>联系人
          </td>
          <td class="after" >
            <el-input v-model="form.contacts" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('phone')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>手机号码
          </td>
          <td class="after" >
            <el-input v-model="form.phone" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('gzh')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>微信公众号
          </td>
          <td class="after" >
            <el-input v-model="form.gzh" placeholder=""></el-input>
          </td>
        </tr>
         <tr>
          <td class="td_left">
            <span v-if="isMandatory('gzhqr')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>公众号二维码
          </td>
          <td class="after">
            <el-upload
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic2"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess1"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('sell')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>销售的产品（服务）
          </td>
          <td class="after" >
            <el-input v-model="form.sell" placeholder=""></el-input>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('buy')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>采购的产品（服务）
          </td>
          <td class="after">
            <el-input v-model="form.buy" placeholder=""></el-input>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>企业内容
          </td>
          <td class="after">
            <div id="qyxxaddeditor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
         <tr>
          <td class="td_left">
            <span v-if="isMandatory('video')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>上传公司视频
          </td>
          <td class="after">
            <el-upload
              class="upload-demo"
              :action="url"
              :limit="1"
              ref="uploadPic3"
              :on-success="onVideoSuccess"
              :on-remove="handleRemoveVideo"
              :before-upload="beforeUploadVideo"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getVidUrl">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <el-button style="margin-left: 15px;" size="small" type="success" @click="preview()">点击预览</el-button>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible1">
              <video-player ref="videoPlayer" :playsinline="true"  :options="playerOptions"></video-player>
            </el-dialog>
          </td>
        </tr>
      </table>
      <div class="btnfixed">
        <el-button type="success" @click="addfn()">添加</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import playVideo from '../../../method/playVideo'
import E from 'wangeditor'
export default {
  props: ['companyData'],
  mixins: [playVideo],
  data()
  {
    //电话—座机验证规则
    let InputTelephone = (rule, value, callback) =>
    {
      let regtel = /^(0\d{2,3})-?(\d{7,8})$/
      if (!value)
        return callback(new Error('电话(座机)不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确座机号'))
        else
          callback()
      }
    }
    //传真验证规则
    let InputFax = (rule, value, callback) =>
    {
      let regtel = /^(0\d{2,3})-?(\d{7,8})$/
      if (this.$route.path === '/Qyzsgl')
      {
        if (value)
        {
          if (!regtel.test(value))
            callback(new Error('请输入正确传真'))
          else
            callback()
        }
      }
      else
      {
        if (!value)
          return callback(new Error('传真不能为空'))
        else
        {
          if (!regtel.test(value))
            callback(new Error('请输入正确传真'))
          else
            callback()
        }
      }
    }
    //邮箱验证规则
    let InputEmail = (rule, value, callback) =>
    {
      let regtel = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!value)
        return callback(new Error('邮箱不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的邮箱'))
        else
          callback()
      }
    }
    //链接验证规则
    // let InputFromurl = (rule, value, callback) =>
    // {
    //   let regtel = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/
    //   if (value)
    //   {
    //     if (!regtel.test(value))
    //       callback(new Error('请输入正确来源链接，http://www.'))
    //     else
    //       callback()
    //   }
    //   else
    //     callback()
    // }
    return {
      url: '',
      form: {
        company: '',
        level: '',
        type: null,
        catid: null,
        business: '',
        mode: [],
        size: null,
        capital: '',
        regunit: null,
        regyear: '',
        address: '',
        postcode: '',
        telephone: '',
        fax: '',
        mail: '',
        homepage: '',
        contacts: '',
        phone: '',
        gzh: '',
        sell: '',
        buy: '',
        introduce: '',
        content: '测试',
        thumb: '',
        gzhqr: '',
        video: '',
        bannerthumb: ''
      },
      // 富文本对象
      editor: null,
      cities: ['制造商', '贸易商', '服务商', '其他机构'],
      //公司类型
      options_companyType: [
        {
          value: '企业单位',
          label: '企业单位'
        },
        {
          value: '事业单位或社会团体',
          label: '事业单位或社会团体'
        },
        {
          value: '个体经营',
          label: '个体经营'
        },
        {
          value: '其他',
          label: '其他'
        }
      ],
      //主营行业
      options_Mainindustry: [
        {
          value: 84,
          label: '设备药剂企业'
        },
        {
          value: 82,
          label: '矿山企业'
        },
        {
          value: 81,
          label: '地勘单位'
        },
        {
          value: 85,
          label: '珠宝企业'
        },
        {
          value: 87,
          label: '投融资企业'
        },
        {
          value: 88,
          label: '贸易企业'
        },
        {
          value: 83,
          label: '科研单位'
        },
        {
          value: 89,
          label: '其它企业'
        }
      ],
      //公司规模
      options_companySize: [
        {
          value: '1-49人',
          label: '1-49人'
        },
        {
          value: '50-99人',
          label: '50-99人'
        },
        {
          value: '100-499人',
          label: '100-499人'
        },
        {
          value: '500-999人',
          label: '500-999人'
        },
        {
          value: '1000-3000人',
          label: '1000-3000人'
        },
        {
          value: '3000-5000人',
          label: '3000-5000人'
        },
        {
          value: '5000-10000人',
          label: '5000-10000人'
        },
        {
          value: '10000以上',
          label: '10000以上'
        }
      ],
      //资本
      options_registeredCapital: [
        {
          value: '人民币',
          label: '人民币'
        },
        {
          value: '港元',
          label: '港元'
        },
        {
          value: '台币',
          label: '台币'
        },
        {
          value: '美元',
          label: '美元'
        },
        {
          value: '欧元',
          label: '欧元'
        },
        {
          value: '英镑',
          label: '英镑'
        }
      ],
      //级别选项
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      //图片预览弹框
      dialogVisible: false,
      //图片预览路径
      dialogImageUrl: '',
      dialogVisible1: false,
      rules: {
        telephone: [{ validator: InputTelephone, trigger: 'blur' }],
        fax: [{ validator: InputFax, trigger: 'blur' }],
        email: [{ validator: InputEmail, trigger: 'blur' }]
        // homepage: [{ validator: InputFromurl, trigger: 'blur' }]
      },
      //表名
      tabname: 'dmcn_company',
      //fld表数据
      fldData: [],
      hideUploadEdit: false
    }
  },
  async created()
  {
    this.$nextTick(() =>
    {
      const editor = new E('#qyxxaddeditor')
      // base64 保存图片
      editor.config.uploadImgShowBase64 = true
      // 关闭粘贴样式的过滤
      editor.config.pasteFilterStyle = false
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = (newHtml) =>
      {
        this.form.content = newHtml
      }
      // 隐藏插入网络图片的功能
      // editor.config.showLinkImg = false;
      // 限制大小
      editor.config.uploadImgMaxSize = 12 * 1024 * 1024 // 2M
      // 限制类型
      editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      // 创建编辑器
      editor.create()
      this.editor = editor
    })
    this.fldData = await window.public.validation(this.tabname)
  },
  mounted()
  {
  },
  methods: {
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    getVidUrl()
    {
      let that = this
      window.public.onUploadVideo(that)
    },
    preview()
    {
      this.playerOptions.sources[0].src = this.form.video
      this.dialogVisible1 = true
    },
    onSuccess1(response)
    {
      let that = this
      window.public.onSuccess1(response, that)
    },
    onSuccess2(response)
    {
      let Ip = window.location.hostname
      let prefix = ''
      if (Ip === 'www.camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else if (Ip === 'camining.cn')
        prefix = 'http://www.camining.cn/uploadfile/'
      else
        prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
      this.form.bannerthumb = `${prefix}${response[0].filename}`
    },
    // 添加信息至公司表
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 26,
        retAtt: 1,
        id: this.companyData.id,
        username: localStorage.getItem('username'),
        company: this.form.company,
        level: this.form.level,
        type: this.form.type,
        catid: this.form.catid,
        business: this.form.business,
        mode: this.form.mode.toString(),
        size: this.form.size,
        capital: this.form.capital,
        regunit: this.form.regunit,
        regyear: this.form.regyear,
        address: this.form.address,
        postcode: this.form.postcode,
        telephone: this.form.telephone,
        fax: this.form.fax,
        mail: this.form.mail,
        homepage: this.form.homepage,
        contacts: this.form.contacts,
        phone: this.form.phone,
        gzh: this.form.gzh,
        sell: this.form.sell,
        buy: this.form.buy,
        introduce: this.form.introduce,
        thumb: this.form.thumb,
        gzhqr: this.form.gzhqr,
        video: this.form.video,
        bannerthumb: this.form.bannerthumb,
        examine: 1
      }
      // 添加信息至公司内容表
      window.post.getPost(obj).then((ret1) =>
      {
        if (ret1.ret === 0)
        {
          let objcontent = {
            cmd: 'addWithId',
            _major: 11,
            _minor: 27,
            retAtt: 1,
            id: this.companyData.id,
            content: this.form.content
          }
          window.post.getPost(objcontent).then((ret2) =>
          {
            if (ret2.ret === 0)
            {
              // 将公司名添加到会员表
              let obj2 = {
                cmd: 'updateAtt',
                _major: 11,
                _minor: 28,
                retAtt: 1,
                id: this.companyData.id,
                company: this.form.company
              }
              window.post.getPost(obj2).then((ret3) =>
              {
                if (ret3.ret === 0)
                {
                  this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
                  this.$emit('iscompanyDataFn', this.form.company)
                  this.$store.commit('onIsLb', '1')
                }
                else
                  this.$message({message: '添加失败，请检查公司名称是否未填写', type: 'error', customClass: 'mzindex'})
              })
            }
            else
              this.$message({message: '添加失败，请检查企业内容是否有未填写', type: 'error', customClass: 'mzindex'})
          })
        }
        else
          this.$message({message: '添加失败，请检查公司信息是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
      })
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //文件上传之前的钩子
    beforeUploadFile(file)
    {
      let that = this
      window.public.beforeUploadFile(file, that)
    },
    //视频上传之前的钩子
    beforeUploadVideo(file)
    {
      let that = this
      window.public.beforeUploadVideo(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handlePictureCardPreview2(file)
    {
      this.dialogImageUrl2 = file.url
      this.dialogVisible2 = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //视频上传成功
    onVideoSuccess(response)
    {
      let that = this
      window.public.onVideoSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //删除文件
    handleRemoveFile(fileList)
    {
      let that = this
      window.public.handleRemoveFile(fileList, that)
    },
    //删除视频
    handleRemoveVideo(fileList)
    {
      let that = this
      window.public.handleRemoveVideo(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/qyxx/QyxxAdd/QyxxAdd.vue